<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [data]="investors"
      [columns]="columns"
      [title]="'admin.sideNav.entities.investors' | translate"
      detailsBaseRoute="/admin/investors"
      [loading]="isLoading()"
    />
  </div>
</div>
